<template>
  <div class="sider_div">
    <el-aside width="100%" style="height:100%;border:0px solid #ebedf0 ">
        <el-menu
            :router=false
            :default-active=activeId
            :collapse="side_Store.isCollapse"
            active-text-color="#409EFF"
            class="el-menu-vertical-demo wi-100 hi-100"
            @select="handleMenuSelect"
            text-color="#434343"
        >
          <myMenu :data="dynamicMenu"></myMenu>
        </el-menu>
    </el-aside>
  </div>
</template>


<script>
import { siderStore } from '@/stores/siderStore'
import {loginUserStore} from "@/stores/loginUserStore";
import myMenu from "@/components/layout/myMenu";
import bus from '@/components/mittBus/mitt';

export default {
  name: "SiderComponent",
  components:{
    myMenu
  },
  data(){
    return{
      dynamicMenu:null,
    }
  },
  setup() {
    const side_Store = siderStore()
    const loginUser_Store = loginUserStore();
    return {
      side_Store,
      loginUser_Store,
      activeId: "1" //side_Store.activeId
    }
  },
  methods: {
    // 替换iframe
    sayHello(event) {
      this.side_Store.setTabStore("http://baidu.com?id="+event.target.id)
    },
    // 初始化菜单
    initMenu(menu){
      this.dynamicMenu = menu;
    },
    // 菜单点击事件
    handleMenuSelect(item) {
      this.activeId = item;
      this.side_Store.activeId = item.toString();
      // 获取权限id,通过id获取整个权限数据
      var PermissionMenu = this.loginUser_Store.getMetaFromDynamicRoutesById(item);
      //console.info(PermissionMenu)
      bus.emit('siderToMain', PermissionMenu)
    }
  },
  mounted() {
    // 初始化获取menu，动态数据绑定
    var menu = this.loginUser_Store.getMenu();
    this.initMenu(menu)
  }
}
</script>

<style scoped>

.sider_div{
  height: 100%;
  border: 1px solid #ebedf0;
  border-bottom: 0px solid red;
  border-top: 0px;
}

:deep(.el-menu) {
  background-color: transparent !important;
}


.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
  height: calc(100vh - 100px);
}

.el-menu{
  border-right: 0px;
}



</style>